<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择消息队列" v-model="para.mqQueue" clearable>
          <k-option v-for="(value, key) in objQueueList" :key="key" :value="key" :label="value" :selected="para.mqQueue == key">
            {{ value }}
          </k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入业务标识" @keydown.enter="onSearch" v-model="para.businessTag" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" v-model="para.processType" clearable>
          <k-option v-for="(value, key) in objStatus" :key="key" :value="key" :label="value" :selected="para.processType == key">
            {{ value }}
          </k-option>
        </k-select>
      </y-query-item>

      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="onChangeDate" :value="pickedTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择创建时间 " style="width: 300px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="arrDataList" :pageIndex="para.pageCurrent" :pageSize="para.pageSize" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="arrDataList && arrDataList.length" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowPopup" layout="header,body,close,mask" title="消息详情" @after-ok="onSave">
      <y-popup-body size="big">
        <div class="mb-2">
          <y-form titleWidth="7em" titleAlign="right" contentWidth="100%">
            <y-form-item title="ID：">
              {{ popupData.id }}
            </y-form-item>
            <y-form-item title="消息队列：">
              {{ popupData.mqQueue }}
            </y-form-item>
            <y-form-item title="业务标识：">
              {{ popupData.mqMsgTag }}
            </y-form-item>
            <y-form-item title="消息标识：">
              {{ popupData.id }}
            </y-form-item>
            <y-form-item title="缓存标识：">
              {{ popupData.cachedTag }}
            </y-form-item>
            <y-form-item title="接口失败原因：">
              {{ popupData.interfaceRst }}
            </y-form-item>
            <y-form-item title="消息处理反馈：">
              {{ popupData.processMsg }}
            </y-form-item>
            <y-form-item title="重试次数：">
              {{ popupData.tryTimes }}
            </y-form-item>
            <y-form-item title="下次重试间隔：">
              {{ popupData.tryPeriod }}
            </y-form-item>
            <y-form-item title="创建时间：">
              {{ popupData.createTime }}
            </y-form-item>
            <y-form-item title="创建人：">
              {{ popupData.createBy }}
            </y-form-item>
          </y-form>
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
/**
 * @name:
 * @description: 消息队列列表
 * @author: zhaoliubin@yuouhui.com
 * @create: 2020-10-15 09:16:00
 * @update: 2020-10-15 09:16:00
 */
// import Mock from 'mockjs';
export default {
  components: {},
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      isShowPopup: false,
      pickedTime: [],
      para: {
        pageCurrent: 1,
        pageSize: 15,
        businessTag: "",
        mqQueue: "",
        processType: "",
        startTime: "",
        endTime: "",
      },
      total: 0,
      arrDataList: [],
      arrQueueList: [],
      popupData: {},

      isLoading: false,
      objStatus: {
        // 0: '成功', 1: '失败-异常', 2: '失败-取消'
      },
      objQueueList: {},
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "ID",
          field: "id",
          style: {
            width: 30,
          },
        },
        {
          name: "消息队列",
          field: "mqQueue",
          style: {
            width: 100,
            "white-space": "normal",
          },
        },
        {
          name: "业务标识",
          field: "businessTag",
          style: {
            width: 120,
            "white-space": "normal",
            "word-break": "break-all",
          },
        },
        {
          name: "消息处理反馈",
          field: "processMsg",
          style: {
            width: 140,
            "white-space": "normal",
          },
        },
        {
          name: "重试次数",
          field: "tryTimes",
          style: {
            width: 40,
          },
        },
        {
          name: "下次重试间隔（分钟）",
          field: "tryPeriod",
          // sorter: false,
          style: {
            width: 80,
          },
        },
        {
          name: "状态",
          field: "processTypeName",
          // sorter: false,
          style: {
            width: 40,
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          // sorter: false,
          style: {
            width: 80,
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 40,
          },
          customRender: (row) => {
            const btnLog = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onCheckLog(row);
                }}
              >
                详情
              </a>
            );
            return <div>{btnLog}</div>;
          },
        },
      ];
    },
    initPageData() {
      let para = this.para;
      this.isLoading = true;
      this.$fetch({
        api: "/nestle-sms-server/mq-logs/page",
        para,
      }).then((res) => {
        this.arrDataList = res.pageList;
        this.total = res.total;
        this.isLoading = false;
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.initPageData();
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.initPageData();
    },
    onReset() {
      this.pickedTime = "";
      this.para = this.$options.data().para;
      this.initPageData();
    },
    onChangeDate(date) {
      this.para.startTime = date[0];
      this.para.endTime = date[1];
      this.pickedTime = date;
    },
    getSearchPara() {
      this.$fetch({
        api: "/nestle-sms-server/mq-dead-letter/option-map",
        para: {},
      })
        .then((res) => {
          this.objStatus = res.processTypeOptionMap;
          this.objQueueList = res.mqQueueOptionMap;
        })
        .catch(() => {});
    },
    onCheckLog(row) {
      this.isShowPopup = true;
      this.$fetch({
        api: "/nestle-sms-server/mq-logs/detail",
        para: { id: row.id },
      })
        .then((res) => {
          console.log(res);

          this.popupData = res;
        })
        .catch(() => {});
    },
  },
  created() {
    this.initPageData();
    setTimeout(() => {
      this.getSearchPara();
    }, 100);
  },
};
</script>

<style lang="postcss" module="css"></style>
